import {assert} from 'Asserts';
import {InventoryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import PrintBarcodeModal from 'label-printing/PrintBarcodeModal';
import {
  CreateMixtureGroupExtras,
  isMixtureGroupWithCreatedMixture,
  MixtureGroupMetadata,
} from 'notebook/integrations/registry/MixtureGroupConstants';
import makeSimpleGroupActionFunction from 'notebook/notes/groups/action-functions/makeSimpleGroupActionFunction';
import {getMixtureGroupAdapter} from 'notebook/notes/groups/NoteLinkedGroupAdapters';
import runModal from 'ui-library/runModal';

const printMixtureGroupBarcodeActionFunction = makeSimpleGroupActionFunction<
  MixtureGroupMetadata,
  CreateMixtureGroupExtras
>({
  label: 'Print Barcode',
  icon: 'format-print',
  onInvoke: ({noteLinkedGroup}) => {
    assert(isMixtureGroupWithCreatedMixture(noteLinkedGroup), 'Cannot print when mixture id is missing');
    const mixtureId = getMixtureGroupAdapter().getMixtureId(noteLinkedGroup)!;
    runModal(PrintBarcodeModal, {itemIds: [mixtureId]});
  },
  getTooltip: ({noteLinkedGroup}) =>
    isMixtureGroupWithCreatedMixture(noteLinkedGroup) ? null : 'Register the mixture to print its barcode',
  getDisabled: ({noteLinkedGroup}) => !isMixtureGroupWithCreatedMixture(noteLinkedGroup),
  getHidden: () => !isFeatureEnabled({feature: InventoryFeature.INVENTORY_EXPORT}),
});

export default printMixtureGroupBarcodeActionFunction;
